import { useState, useEffect } from 'react';

export default function useTypingEffect(value, speed = 50) {
  const [text, setText] = useState('');
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    let i = 0;

    const intervalId = setInterval(() => {
      setIsAnimating(true);
      setText(prev => {
        if (i === value.length) {
          clearInterval(intervalId);
          setTimeout(() => {
            setIsAnimating(false);
          }, 1000);
          return prev;
        }
        return prev + value[i++];
      });
    }, speed);

    return () => {
      clearInterval(intervalId);
      setText('');
    };
  }, [value, speed]);

  return { text, isAnimating };
}
